import { lazy, Suspense, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { Route, Switch, withRouter } from "react-router-dom";
import PropTypes from "prop-types";

// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./pages/auth/redux/authSelector";
/// Style
import "react-toastify/dist/ReactToastify.css";
import "./assets/vendor/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./assets/css/style.css";
import "./assets/scss/main.scss";
// routes
import AppRoutes from "./routes/AppRoutes";
import { ROUTE } from "./constants/app_routes";
import Preloader from "./components/common/Preloader";

const Login = lazy(() => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(import("./pages/auth/Login")), 500);
  });
});

function App(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    checkAutoLogin(dispatch, props.history);
  }, [dispatch, props.history, isAuthenticated]);

  const routes = (
    <Switch>
      <Route path={ROUTE.login} component={Login} />
    </Switch>
  );

  if (props.isAuthenticated) {
    return (
      <Suspense fallback={<Preloader />}>
        <AppRoutes />
      </Suspense>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense fallback={<Preloader />}>{routes}</Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { isAuthenticated: isAuthenticated(state) };
};

App.propTypes = {
  history: PropTypes.object,
  isAuthenticated: PropTypes.bool,
};

export default withRouter(connect(mapStateToProps)(App));
